(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('.vvi-track');
    const previous = root.querySelector('[data-vvi-prev]');
    const next = root.querySelector('[data-vvi-next]');
    const update = () => {
      previous.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    const move = direction => {
      const card = track.querySelector('.vvi-card');
      const distance = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap) : track.clientWidth;
      track.scrollBy({left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, {passive:true});
    new ResizeObserver(update).observe(track);
    root.querySelectorAll('[data-vvi-play]').forEach(button => {
      const video = button.parentElement.querySelector('video');
      button.addEventListener('click', () => {
        button.hidden = true;
        video.play().catch(() => { button.hidden = false; });
      });
      video.addEventListener('play', () => {
        button.hidden = true;
        root.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
      });
      video.addEventListener('ended', () => { button.hidden = false; });
    });
    update();
  }
  document.querySelectorAll('[data-vvi]').forEach(init);
  if (!window.vitalaVideoInformationBound) {
    window.vitalaVideoInformationBound = true;
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-vvi]').forEach(init));
  }
})();
